<section
  class="bg-gradient-to-b from-gray-50 to-white py-16 md:py-20 px-5 md:px-10"
>
  <div class="max-w-7xl mx-auto">
    <div class="text-center mb-12 animate-fadeInUp">
      <h1 class="text-primary text-3xl md:text-5xl font-bold mb-4">
        Nuestros <span class="text-secondary">Filtros</span>
      </h1>
      <div class="h-1 w-24 bg-secondary rounded-full mx-auto mb-6"></div>
      <p class="text-gray-700 text-lg max-w-3xl mx-auto">
        Los equipos everfull trabajan con la mejor tecnología en purificación
        de agua. Nuestros filtros cumplen con todos los requerimientos
        necesarios para proveer agua libre de impurezas.
      </p>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
      <!-- Información de filtros -->
      <div class="space-y-6 animate-fadeInUp" style="animation-delay: 0.2s">
        <!-- Filtro de Polipropileno -->
        <div
          class="bg-white rounded-2xl p-6 shadow-soft hover:shadow-medium transition-all duration-300 border-l-4 border-secondary"
        >
          <div class="flex items-start gap-4">
            <div class="flex-shrink-0">
              <div
                class="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center"
              >
                <span class="text-secondary font-bold text-lg">1</span>
              </div>
            </div>
            <div>
              <h3 class="text-secondary font-bold text-xl mb-2">
                Filtro de Polipropileno
              </h3>
              <p class="text-gray-700 leading-relaxed">
                Retiene todos los sedimentos, las impurezas y suciedades
                superiores a un micrón nominal, como la arenilla y tierra que
                puede contener el agua. Además protege al cartucho de carbón
                activado.
              </p>
            </div>
          </div>
        </div>

        <!-- Filtro de Carbón Activado -->
        <div
          class="bg-white rounded-2xl p-6 shadow-soft hover:shadow-medium transition-all duration-300 border-l-4 border-primary"
        >
          <div class="flex items-start gap-4">
            <div class="flex-shrink-0">
              <div
                class="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center"
              >
                <span class="text-primary font-bold text-lg">2</span>
              </div>
            </div>
            <div>
              <h3 class="text-primary font-bold text-xl mb-2">
                Filtro de Carbón Activado Impregnado en Plata
              </h3>
              <p class="text-gray-700 leading-relaxed">
                Reduce el 99,5% del contenido de cloro del agua de red respecto
                de una concentración de prueba de 2,10 mg/l. Reduce el olor y
                sabor a cloro.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Visualización de filtros -->
      <div
        class="flex justify-center items-center gap-8 md:gap-12 py-8 pb-16 animate-fadeInUp"
        style="animation-delay: 0.4s"
      >
        <!-- Paso 1 -->
        <div class="flex flex-col items-center group">
          <div
            class="bg-white rounded-2xl p-6 shadow-medium hover:shadow-strong transition-all duration-300 hover:-translate-y-2 mb-6"
          >
            <img
              src="./assets/filtro_sedimentos.png"
              class="w-28 h-28 object-contain"
              alt="Filtro de sedimentos"
            />
          </div>
          <div class="relative mb-10">
            <div
              class="bg-gradient-to-br from-secondary to-green-600 text-white rounded-full h-16 w-16 flex items-center justify-center font-bold text-lg shadow-medium group-hover:scale-110 transition-transform duration-300"
            >
              1
            </div>
            <div
              class="absolute -bottom-9 left-1/2 transform -translate-x-1/2 whitespace-nowrap"
            >
              <span class="text-secondary font-bold text-sm">Paso 1</span>
            </div>
          </div>
        </div>

        <!-- Flecha -->
        <div class="hidden md:block">
          <svg
            class="w-12 h-12 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 7l5 5m0 0l-5 5m5-5H6"
            />
          </svg>
        </div>

        <!-- Paso 2 -->
        <div class="flex flex-col items-center group">
          <div
            class="bg-white rounded-2xl p-6 shadow-medium hover:shadow-strong transition-all duration-300 hover:-translate-y-2 mb-6"
          >
            <img
              src="./assets/filtro_carbon.png"
              class="w-28 h-28 object-contain"
              alt="Filtro de carbón"
            />
          </div>
          <div class="relative mb-10">
            <div
              class="bg-gradient-to-br from-primary to-blue-800 text-white rounded-full h-16 w-16 flex items-center justify-center font-bold text-lg shadow-medium group-hover:scale-110 transition-transform duration-300"
            >
              2
            </div>
            <div
              class="absolute -bottom-9 left-1/2 transform -translate-x-1/2 whitespace-nowrap"
            >
              <span class="text-primary font-bold text-sm">Paso 2</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Resultado final -->
    <div
      class="mt-16 text-center animate-fadeInUp"
      style="animation-delay: 0.6s"
    >
      <div
        class="inline-flex items-center bg-gradient-to-r from-secondary/10 to-primary/10 border border-secondary/30 rounded-full px-8 py-4"
      >
        <svg
          class="w-6 h-6 mr-3 text-secondary"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clip-rule="evenodd"
          />
        </svg>
        <span class="text-primary font-bold text-lg">
          = Agua purificada, cristalina y lista para disfrutar
        </span>
      </div>
    </div>
  </div>
</section>
